import { useEffect } from "react";
import { useQuery } from "react-query";
import { getConsignmentTypes } from "services/options";

export default function useGetConsignmentTypes() {
  const token = localStorage.getItem("token");
  const { data, isLoading } = useQuery(
    ["core-api-consignment-types", token],
    getConsignmentTypes
  );
  useEffect(() => {
    if (data && !isLoading) {
      localStorage.setItem(
        "coreApiConsignmentTypes",
        JSON.stringify(data.payload)
      );
    }
  }, [data, isLoading]);
}
